import React from 'react';
import Head from 'next/head';

interface MetadataProps {
  title: string;
  ogTitle?: string;
  twitterTitle?: string;
  description: string;
  ogDescription?: string;
  twitterDescription?: string;
  ogImage?: string;
  twitterImage?: string;
}

const Metadata: React.FC<MetadataProps> = ({
  title,
  ogTitle,
  twitterTitle,
  description,
  ogDescription,
  twitterDescription,
  ogImage,
  twitterImage,
}) => {
  return (
    <Head>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta property="og:title" content={ogTitle || title} />
      <meta property="og:description" content={ogDescription || description} />
      {ogImage && <meta property="og:image" content={ogImage} />}
      <meta property="twitter:title" content={twitterTitle || title} />
      <meta
        property="twitter:description"
        content={twitterDescription || description}
      />
      {(twitterImage || ogImage) && (
        <meta property="twitter:image" content={twitterImage || ogImage} />
      )}
    </Head>
  );
};

export default Metadata;
